/**
 * How a `BUILD_PLACEMENT_TIMED_OUT` reason carries the executor's own word on
 * the capacity wait — Nomad's placement failure (`awaiting placement: Dimension
 * "cpu" exhausted on 3 nodes`), CodeBuild's waiting phase — so the console can
 * quote it back without guessing where the platform's sentence ends.
 *
 * The control plane's timeout sweep writes the detail LAST, verbatim, behind
 * this label; the console reads everything after the label's FIRST occurrence —
 * the sweep's own sentence never contains it, and the executor's words might.
 * One string, shared, so the writer and the reader cannot drift apart.
 *
 * The span it returns is quoted and never classified on: the card is chosen by
 * the reason CODE, and the detail is words a tenant's scheduler produced.
 */
export const VIBE_PLACEMENT_DETAIL_LABEL = "The executor last reported:";

/** The reason a capacity-wait timeout carries: the sweep's sentence, then the detail. */
export function composeVibePlacementTimeoutReason(sentence: string, detail: string): string {
  return `${sentence} ${VIBE_PLACEMENT_DETAIL_LABEL} ${detail}`;
}

/**
 * The executor's word quoted at the end of a capacity-wait reason, or `null`
 * when the reason carries none — a build whose executor never described its
 * wait, or a reason written before the detail was recorded.
 */
export function readVibePlacementTimeoutDetail(reason: string): string | null {
  const at = reason.indexOf(VIBE_PLACEMENT_DETAIL_LABEL);
  if (at === -1) return null;
  const detail = reason.slice(at + VIBE_PLACEMENT_DETAIL_LABEL.length).trim();
  return detail === "" ? null : detail;
}
